import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router, NavigationEnd } from '@angular/router';

declare let gtag: Function;
@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {


  constructor(private router: Router){
    this.init();
  }

  public init() {
    // this.listenForRouteChanges();

    try {
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = 'https://www.googletagmanager.com/gtag/js?id=' + "UA-166270085-8";
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '` + 'UA-166270085-8' + `', {'send_page_view': true});
      `;
      document.head.appendChild(script2);
    } catch (ex) {
      console.error('Error appending google analytics');
      console.error(ex);
    }
  }

  private listenForRouteChanges() {
    if (environment.Use_Analytics) {
      this.router.events.subscribe(event => {
        console.log(event)
          this.setPage('/','Home');
        // }
      });
    }
  }

  setPage(pageUrl,pageTitle) {
    gtag('config',"UA-166270085-8", { 'app_name': 'Scholarship Portal', 'app_version': '4.8','page_title':pageTitle,'page_path':pageUrl });
   }

  sendPageView() {
    gtag('send', 'pageview');
  }

  sendPageEvent(eventCategory: string, eventAction: string) {
    if (environment.Use_Analytics) {
      gtag('event', 'click', {
        'event_category': eventCategory,
        'event_action': eventAction,
        'app_version': '1.0.1'
      });
      // console.log('Sending Google Analytics hit for event', eventCategory);
    }
  }
}
